import {
  IAnnouncementsResponse,
  ITrendingItem,
  IWatchlistPerformers,
} from '@kattana-io/common';
import { LOAD_REGISTRY_DONE } from '../actions/registry';

/**
 * Hold typical cases for UI state
 */
export interface IRegistryReducer {
  news: IAnnouncementsResponse[];
  trending: ITrendingItem[];
  gainers?: IWatchlistPerformers;
  loading: boolean;
}

const defaultState: IRegistryReducer = {
  news: [],
  trending: [],
  gainers: {
    pairs: [],
    yesterday_prices: {},
  },
  loading: true,
};

const registryReducer = (
  state: IRegistryReducer = defaultState,
  action: any
): IRegistryReducer => {
  switch (action.type) {
  case LOAD_REGISTRY_DONE:
    return {
      loading: false,
      ...action.payload,
    };
  default:
    return state;
  }
};

export default registryReducer;
